(() => {
  const panelSelector = '.prescription--js';
  const dockSelectors = [
    '[data-two-nu-product-dock]',
    '.two-nu-product-dock',
    '.two-nu-page-dock',
    '[data-two-nu-home-dock]',
    '.two-nu-home-dock',
    '.run-v2-dock'
  ];
  const modeClasses = [
    'prescription--dock-horizontal',
    'prescription--dock-vertical',
    'prescription--dock-fallback'
  ];

  const clamp = (value, min, max) => Math.max(min, Math.min(value, max));

  const isVisible = (element) => {
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    return (
      rect.width > 20 &&
      rect.height > 20 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  };

  const getDockPriority = (element) => {
    if (element.matches('[data-two-nu-product-dock], .two-nu-product-dock')) return 5;
    if (element.matches('.two-nu-page-dock, .run-v2-dock')) return 4;
    if (element.matches('[data-two-nu-home-dock], .two-nu-home-dock')) return 3;
    return 1;
  };

  const findDock = () => {
    const candidates = dockSelectors
      .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
      .filter((element, index, list) => list.indexOf(element) === index)
      .filter(isVisible)
      .map((element) => {
        const rect = element.getBoundingClientRect();

        return {
          element,
          rect,
          priority: getDockPriority(element),
          area: rect.width * rect.height
        };
      })
      .sort((a, b) => b.priority - a.priority || b.area - a.area);

    return candidates[0] || null;
  };

  const setVar = (element, name, value) => {
    element.style.setProperty(name, value);
  };

  const syncPrescriptionToDock = () => {
    const panel = document.querySelector(panelSelector);
    if (!panel) return;

    panel.classList.remove(...modeClasses, 'prescription--desktop-left');

    if (window.matchMedia('(min-width: 750px)').matches) {
      panel.classList.add('prescription--desktop-left');
      return;
    }

    const dock = findDock();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const safeGap = 10;

    if (!dock) {
      panel.classList.add('prescription--dock-fallback');
      setVar(panel, '--prescription-dock-width', `${Math.min(820, viewportWidth - 32)}px`);
      setVar(panel, '--prescription-dock-bottom', '96px');
      setVar(panel, '--prescription-dock-max-height', `${Math.max(300, viewportHeight - 128)}px`);
      return;
    }

    const rect = dock.rect;
    const isVerticalDock = rect.height > rect.width * 1.35 || (viewportWidth < 750 && rect.height > rect.width);

    if (isVerticalDock) {
      const dockRight = viewportWidth - rect.left;
      const right = clamp(dockRight + safeGap, 46, viewportWidth - 248);
      const width = clamp(rect.left - safeGap - 12, 248, Math.min(430, viewportWidth - right - 8));
      const height = clamp(rect.height, 260, viewportHeight - 24);
      const top = clamp(rect.top, 8, viewportHeight - height - 8);

      panel.classList.add('prescription--dock-vertical');
      setVar(panel, '--prescription-dock-top', `${Math.round(top)}px`);
      setVar(panel, '--prescription-dock-right', `${Math.round(right)}px`);
      setVar(panel, '--prescription-dock-width', `${Math.round(width)}px`);
      setVar(panel, '--prescription-dock-height', `${Math.round(height)}px`);
      return;
    }

    const width = clamp(rect.width, 420, viewportWidth - 32);
    const left = clamp(rect.left, 16, viewportWidth - width - 16);
    const bottom = clamp(viewportHeight - rect.top + safeGap, 72, viewportHeight - 280);
    const maxHeight = Math.max(300, viewportHeight - bottom - 16);

    panel.classList.add('prescription--dock-horizontal');
    setVar(panel, '--prescription-dock-left', `${Math.round(left)}px`);
    setVar(panel, '--prescription-dock-width', `${Math.round(width)}px`);
    setVar(panel, '--prescription-dock-bottom', `${Math.round(bottom)}px`);
    setVar(panel, '--prescription-dock-max-height', `${Math.round(maxHeight)}px`);
  };

  const scheduleSync = () => window.requestAnimationFrame(syncPrescriptionToDock);

  window.twoNuSyncPrescriptionDock = syncPrescriptionToDock;

  ['activate-pdp-prescription', 'activate-plp-prescription'].forEach((eventName) => {
    window.addEventListener(eventName, syncPrescriptionToDock, true);
  });

  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', scheduleSync, { passive: true });
  window.addEventListener('scroll', () => {
    if (document.querySelector(`${panelSelector}.open`)) scheduleSync();
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
